/* istanbul ignore file */
import { FailedToLoad } from '@ms/yammer-error-components';
import ErrorBoundary from '@ms/yammer-libs-error-boundary';
import type { FC } from 'react';
import React from 'react';

import App from './App';

const AppBoundary: FC = () => (
  <ErrorBoundary ErrorComponent={FailedToLoad} name="App">
    <App />
  </ErrorBoundary>
);

export default AppBoundary;
